import { observable, configure } from 'mobx';
import { RouterStore } from '@superwf/mobx-react-router';
import { createBrowserHistory } from "history";
const browserHistory = createBrowserHistory();

export const pageRouter = new RouterStore(browserHistory);